import React from 'react';
import { AsistenciaEntregada } from '../asistencia/AsistenciaEntregada';

export const EntregaHumanitaria: React.FC = () => {
  return <AsistenciaEntregada />;
};
